// extracted by mini-css-extract-plugin
export var actions = "_f7-g";
export var benefitCard = "_f7-b";
export var benefitIcon = "_f7-d";
export var benefitLabel = "_f7-f";
export var benefits = "_f7-a";
export var benefitsSection = "_f7-8";
export var bodyText = "_f7-7";
export var closeButton = "_f7-2";
export var content = "_f7-3";
export var eyebrow = "_f7-4";
export var heading = "_f7-5";
export var image = "_f7-i";
export var imagePanel = "_f7-h";
export var modal = "_f7-0";
export var offerCard = "_f7-c";
export var offerIcon = "_f7-e";
export var sectionLabel = "_f7-9";
export var shell = "_f7-1";
export var title = "_f7-6";